export default __webpack_public_path__ + "static/media/customer4.6a59e8d8.svg";